import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import TransitionPage from 'containers/TransitionPage'
import CreateAccountForm from 'components/organisms/CreateAccountForm'

export const styles = theme => ({
  root: {
    width: 328,
    margin: '0 auto',
    position: 'relative',
    ...theme.components.accountPage,
  },
  subtitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
  backButton: {
    ...theme.components.backButton,
  },
})

const CreateAccount = ({
  classes, errorMessage, onCreateSubmit, hasError
}) => (
  <TransitionPage>
    <div className={classes.root}>
      <Typography variant="h1">
          Nice to <br />
          meet you!
      </Typography>
      <CreateAccountForm
        onCreateSubmit={onCreateSubmit}
        apiCallError={hasError}
        errorMessage={errorMessage}
        showSignin
      />
    </div>
  </TransitionPage>
)

CreateAccount.propTypes = {
  hasError: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onBackPress: PropTypes.func,
  errorMessage: PropTypes.string,
  onCreateSubmit: PropTypes.func,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(CreateAccount)



// WEBPACK FOOTER //
// ./src/containers/account/CreateAccount/CreateAccount.js